import { EVENTS, trackEvent } from "@/services/analytics";
import { useCallback, useEffect, useState } from "react";

const KEY = "peasy-chat-paywall";
const LIMIT = 7;

export const usePaywall = (id: string) => {
  const [count, setCount] = useState<number>();

  useEffect(() => {
    const count = localStorage.getItem(`${KEY}-${id}`);
    setCount(Number(count) || 0);
  }, []);

  const incCount = useCallback(() => {
    // No-op since we're removing the paywall
  }, []);

  useEffect(() => {
    if (count && count >= LIMIT) {
      trackEvent(EVENTS.PAYWALL);
    }
  }, [count]);

  return {
    count: 0,
    isActive: false,
    isLoading: false,
    incCount,
  };
};
